module.exports = __webpack_public_path__ + "b68cfc97391ee306ce3ccb3ac4add294.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/velikonocni-tabor-3.jpg
// module id = 1203
// module chunks = 0